import { Component, OnInit } from '@angular/core';
import { ASSETS_PATH } from 'src/app/core/config';
import { GENDER_TYPES } from 'src/app/core/models/enum.model';
import { VolunteerFilter, VolunteerViewModel } from 'src/app/core/models/volunteer.model';
import { AlertService } from 'src/app/core/services/alert.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { LoadingService } from 'src/app/core/services/loading.service';
import { VolunteerService } from 'src/app/core/services/volunteer.service';

@Component({
  selector: 'app-volunteer',
  templateUrl: './volunteer.component.html',
  styleUrls: ['./volunteer.component.scss']
})
export class VolunteerComponent implements OnInit {
  volunteers: VolunteerViewModel[] = [];
  filteredVolunteers: VolunteerViewModel[] = [];
  tableCardList: VolunteerViewModel[] = [];
  assetsPath = ASSETS_PATH;
  excelPath = null;
  genderTypes = GENDER_TYPES;
  totalRow = 0;
  rowPerPage = 25;
  currentPageNum = 0;
  filters = new VolunteerFilter();
  cities = [];
  universities = [];

  constructor(private volunteerService: VolunteerService,
    private alertService: AlertService,
    private loadingService: LoadingService,
    private authService: AuthService) { }

  ngOnInit(): void {
    this.loadingService.setLoading(true);
    this.getVolunteers();
    this.getCities();
    this.getUniversities();
    if (localStorage.getItem('volunteer-filters') ) {      
      this.filters = JSON.parse(localStorage.getItem('volunteer-filters'));
      this.filterResults();
    }
  }

  getVolunteers() {
    this.volunteerService.getVolunteers().subscribe(response => {
      if (response.success) {
        this.volunteers = this.filteredVolunteers = response.volunteers;
        this.tableCardList = this.filteredVolunteers.slice(this.rowPerPage*this.currentPageNum, this.rowPerPage*(this.currentPageNum+1));
      }
      else {
        this.alertService.alert('Hata!', 'Gönüllü listesi çekilemedi!', 'error');
      }
      this.loadingService.setLoading(false);
    });
  }

  async getCities() {
    const data: any = await this.authService.getUserToken().toPromise();
    this.authService.getCitySelectList(data.token).subscribe(response => {
      if (response.success) {
        this.cities = response.cities;
      }
    });
  }

  async getUniversities() {
    const data: any = await this.authService.getUserToken().toPromise();
    this.authService.getUniversitySelectList(data.token).subscribe(response => {
      if (response.success) {
        this.universities = response.universities;
      }
    });
  }

  filterResults() {
    console.log(this.filters);
    localStorage.setItem('volunteer-filters', JSON.stringify(this.filters));
    this.loadingService.setLoading(true);
    this.volunteerService.filterVolunteers(this.filters).subscribe(response => {
      if (response.success) {
        this.currentPageNum = 0;
        this.volunteers = this.filteredVolunteers = response.volunteers;
        this.tableCardList = this.filteredVolunteers.slice(this.rowPerPage*this.currentPageNum, this.rowPerPage*(this.currentPageNum+1));
        this.alertService.notification('Başarılı!', 'Gönüllüler başarıyla filtrelendi.', 'success');
      }
      else {
        this.alertService.alert('Hata!', 'Gönüllüler alınamadı.', 'error');
      }
      this.loadingService.setLoading(false);
    });
  }

  resetFilters() {
    this.filters = {
      fullName: null,
      email: null,
      gender: null,
      companyName: null,
      position: null,
      universityId: null,
      school: null,
      departmant: null,
      phone: null,
      primaryCityId: null,
      secondaryCityId: null
    };
    localStorage.removeItem('volunteer-filters');
    this.loadingService.setLoading(true);
    this.getVolunteers();
  }

  incrementPage(){
    if ((this.currentPageNum+1)*this.rowPerPage < this.filteredVolunteers.length) {
      this.currentPageNum += 1;
      this.loadingService.setLoading(true);
      this.tableCardList = this.filteredVolunteers.slice(this.rowPerPage*this.currentPageNum, this.rowPerPage*(this.currentPageNum+1));
      this.loadingService.setLoading(false);
    }
  }

  decrementPage(){
    if (this.currentPageNum>0){
      this.currentPageNum -= 1;
      this.loadingService.setLoading(true);
      this.tableCardList = this.filteredVolunteers.slice(this.rowPerPage*this.currentPageNum, this.rowPerPage*(this.currentPageNum+1));
      this.loadingService.setLoading(false);
    }
  }

  setFirstPage(){
    this.currentPageNum = 0;
    this.loadingService.setLoading(true);
    this.tableCardList = this.filteredVolunteers.slice(this.rowPerPage*this.currentPageNum, this.rowPerPage*(this.currentPageNum+1));
    this.loadingService.setLoading(false);
  }

  setLastPage(){
    if ((this.filteredVolunteers.length / this.rowPerPage) > Math.floor((this.filteredVolunteers.length / this.rowPerPage))){
      this.currentPageNum =  Math.floor((this.filteredVolunteers.length / this.rowPerPage));
    }
    else {
      this.currentPageNum =  Math.floor((this.filteredVolunteers.length / this.rowPerPage)) - 1;
    }
    this.loadingService.setLoading(true);
    this.tableCardList = this.filteredVolunteers.slice(this.rowPerPage*this.currentPageNum, this.rowPerPage*(this.currentPageNum+1));
    this.loadingService.setLoading(false);
  }

  excelExport(){
    this.loadingService.setLoading(true);
    this.volunteerService.filterExcelVolunteers(this.filters).subscribe(response => {
      if (response.success) {
        this.excelPath = response.excelPath;
        this.alertService.alert('Başarılı!', 'Gönüllü listesi başarıyla excel olarak oluşturuldu.', 'success');
      }
      else {
        this.alertService.alert('Hata!', 'Gönüllü listesi excel dosyası oluşturulamadı!', 'error');
      }
      this.loadingService.setLoading(false);
    });
  }

}
